import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
// import {AppBar, Toolbar, Typography,} from "@material-ui/core";
import Nav from './nav';
import axios from 'axios';

import React, {Component} from 'react';
import {Alert, Container, Grid} from "@mui/material";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

axios.defaults.baseURL = window.location.protocol + '//' + window.location.host.replace("3000", "8007");


class VideoSearch extends Component {

    state = {
        // Initially, no file is selected
        selectedFile: null,
        foundImage: null,
        foundTime: null,
        foundDistance: null,
        hideSimilar: false
    };

    handleCheck = event => {
        this.setState({hideSimilar: event.target.checked});
    }


    // On file select (from the pop up)
    onFileChange = event => {
        // Update the state
        console.log(event.target.files[0]);
        this.setState({
            selectedFile: event.target.files[0],
            foundImage: null,
        });
    };

    // On file upload (click the upload button)
    onFileUpload = () => {
        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        formData.append(
            "video",
            this.state.selectedFile,
            this.state.selectedFile.name
        );

        // Request made to the backend api
        // Send formData object
        axios.post("/search_video", formData)
            .then(r => {
                this.setState({
                    foundImage: "data:image/png;base64," + r.data.image,
                    foundTime: r.data.text,
                    foundDistance: r.data.distance
                })
            })
    };


    // File content to be displayed after
    // file upload is complete
    fileData = () => {
        if (this.state.foundImage && ((this.state.foundDistance <= 0.51 && this.state.hideSimilar) || this.state.foundDistance > 0.51 && !this.state.hideSimilar)) {
            return (
                <div>
                    <br/>
                    <Alert severity="info">{this.state.foundTime}</Alert>
                    <Alert severity="info">Расстояние: {this.state.foundDistance}</Alert>
                    <h2>Похожее изображение:</h2>
                    <img className="foundImage" src={this.state.foundImage} alt="Found image"/>
                </div>
            )
        }

        if (this.state.foundImage && this.state.foundDistance > 0.51 && this.state.hideSimilar) {
            return (
                <div>
                    <br/>
                    <Alert severity="info">{this.state.foundTime}</Alert>
                    <h2>Похожее изображение не было найдено</h2>
                </div>
            )
        }

        if (this.state.selectedFile) {

            return (
                <div>
                    <h2>Информация об изображении:</h2>

                    <p>Имя файла: {this.state.selectedFile.name}</p>

                    <p>Тип файла: {this.state.selectedFile.type}</p>

                    <p>
                        Дата последнего изменения:{" "}
                        {this.state.selectedFile.lastModifiedDate.toDateString()}
                    </p>

                    <img className="uploadedImage" src={URL.createObjectURL(this.state.selectedFile)}/>

                </div>
            );
        } else {
            return (
                <div>
                    <br/>
                    <h4>Выберите файл для поиска</h4>
                </div>
            );
        }
    };

    render() {

        return (
            <Container>
                <Nav/>
                <div>
                    <h1>
                        Поиск по видео
                    </h1>
                    <div>
                            <FormControlLabel
                                control={<Checkbox onChange={this.handleCheck}/>}
                                label="Исключать похожие лица"
                            />
                        <Grid container spacing={2}>
                            <Grid item xs={6}>

                                <Button variant="contained" component="label" color="primary">
                                    {" "}
                                    Загрузить видео
                                    <input id="image" type="file" onChange={this.onFileChange} hidden/>
                                </Button>
                            </Grid>

                            {/*<input type="file" onChange={this.onFileChange} />*/}
                            <Grid item xs={6}>
                                <Button variant="contained" component="label" color="primary">
                                    {" "}
                                    Искать по видео
                                    <input type="button" onClick={this.onFileUpload} hidden/>
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                    {this.fileData()}
                </div>
            </Container>
        );
    }
}

{/*    </Container>*/
}
{/*    );*/
}
{/*}*/
}


export default VideoSearch;
